module.exports = __webpack_public_path__ + "img/Icon Container (2).c43270aa.png";